const state = () => ({
  color: localStorage.getItem("color") || "#00365f",
  color_text: localStorage.getItem("color_text") || "#00365f",
  font_family: localStorage.getItem("font_family") || "Nunito Sans, sans-serif",
  logo: localStorage.getItem("logo") || "",
  crm: localStorage.getItem("crm") || "",
});

const getters = {
  color: (s) => s.color,
  color_text: (s) => s.color_text,
  font_family: (s) => s.font_family,
  logo: (s) => s.logo,
  crm: (s) => s.crm,
};

const mutations = {
  setColor(state, v) {
    state.color = v;
    if (v) localStorage.setItem("color", v);
    else localStorage.removeItem("color");
  },
  setColorText(state, v) {
    state.color_text = v;
    if (v) localStorage.setItem("color_text", v);
    else localStorage.removeItem("color_text");
  },
  setFontFamily(state, v) {
    state.font_family = v;
    if (v) localStorage.setItem("font_family", v);
    else localStorage.removeItem("font_family");
  },
  setLogo(state, v) {
    state.logo = v;
    if (v) localStorage.setItem("logo", v);
    else localStorage.removeItem("logo");
  },
  setCrm(state, v) {
    state.crm = v;
    if (v) localStorage.setItem("crm", v);
    else localStorage.removeItem("crm");
  },
};

const actions = {
  updateBranding({ commit }, payload) {
    if (payload.color) commit("setColor", payload.color);
    if (payload.color_text) commit("setColorText", payload.color_text);
    if (payload.font_family) commit("setFontFamily", payload.font_family);
    if (payload.logo) commit("setLogo", payload.logo);
    if (payload.crm) commit("setCrm", payload.crm);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
